import useMoyasarHook from "@/pages/checkout/CheckoutV2/hooks/useMoyasarHook";
import useCheckoutDotComHook from "@/pages/checkout/CheckoutV2/hooks/useCheckoutDotComHook";
import "@/pages/checkout/moyasar/styles.css";
function usePaymentHook(_ref) {
  var divSelector = _ref.divSelector,
    paymentSession = _ref.paymentSession,
    events = _ref.events,
    template = _ref.template,
    _ref$internvalTimeout = _ref.internvalTimeoutSeconds,
    internvalTimeoutSeconds = _ref$internvalTimeout === void 0 ? 10 : _ref$internvalTimeout,
    gatewayType = _ref.gatewayType;
  if (gatewayType === "moyasar") {
    useMoyasarHook({
      divSelector: divSelector,
      paymentSession: paymentSession,
      events: events,
      template: template,
      internvalTimeoutSeconds: internvalTimeoutSeconds
    });
  } else if (gatewayType === "checkout.com") {
    useCheckoutDotComHook({
      divSelector: divSelector,
      paymentSession: paymentSession,
      events: events,
      template: template,
      internvalTimeoutSeconds: internvalTimeoutSeconds
    });
  } else {
    throw new Error("Unsupported gateway");
  }
}
export default usePaymentHook;